import TheFooter from "./components/the-footer";
import { sizes, subscribe, unsubscribe } from "./utils/media-query";

import { locale, loadMessages } from "devextreme/localization";

import enMessages from "@/env/messages/en.json";
import koMessages from "@/env/messages/ko.json";

import supplemental from "devextreme-cldr-data/supplemental.json";
import koCldrData from "@/env/ko.json";
import enCldrData from "@/env/en.json";
//import enCldrData from "devextreme-cldr-data/en.json";

import Globalize from "globalize";

import BaseComponent from "@/components/base/BaseComponent";
import http from "@/service/util/http.js";
import commonApi from "@/service/util/commonApi.js";

function getScreenSizeInfo() {
  const screenSizes = sizes();
  return {
    isXSmall: screenSizes["screen-x-small"],
    isLarge: screenSizes["screen-large"],
    cssClasses: Object.keys(screenSizes).filter((cl) => screenSizes[cl]),
  };
}

export default {
  mixins: [BaseComponent],
  name: "app",
  data() {
    return {
      title: this.$appInfo.title,
      screen: getScreenSizeInfo(),
      // locale: "ko",
      // locales: null,
    };
  },

  computed: {
    cssClasses() {
      return ["app"].concat(this.screen.cssClasses);
    },
  },
  methods: {
    changeLocale(e) {
      this.UserLib.fnChangeLocale(e.value);
      this.$router.go();
      //document.location.reload();
    },

    screenSizeChanged() {
      this.screen = getScreenSizeInfo();
    },
    getUserConfig: async function() {
      const res = await commonApi.getUserConfig();
      localStorage.setItem("userId", res.data.userInfo.emplyrId);
      localStorage.setItem("userNm", res.data.userInfo.userNm);
      localStorage.setItem("memberEtcType", res.data.userInfo.memberEtcType);
      this.sysConfig.userInfo = res.data.userInfo;
      this.sysConfig.members = res.data.members;
      this.sysConfig.compInfo = res.data.compInfo;
    },
    getCommonGroup: async function() {
      const res = await commonApi.getCommonGroup();
      this.commonCode.commonGroup = res.data.content;
    },
    getCommonDetail: async function() {
      const res = await commonApi.getCommonDetail();
      this.commonCode.commonDetail = res.data.content;
    },
  },

  mounted() {
    subscribe(this.screenSizeChanged);
  },

  beforeDestroy() {
    unsubscribe(this.screenSizeChanged);
  },

  created() {
    //devextreme-cldr-data/   formating string ko.json 확인
    Globalize.load(supplemental, koCldrData, enCldrData);
    Globalize.loadMessages(koMessages);

    let token = localStorage.getItem("jwt");
    token = this.UserLib.fnStrIsEmpty(token) ? "" : token;

    if (token) {
      this.sysConfig.token = token;
      http.setAuthorization(token);
      this.getUserConfig();
      this.getCommonGroup();
      this.getCommonDetail();
    } else {
      this.$router.push({ name: "login" });
    }
  },

  components: {
    TheFooter,
  },
};
